import { render, staticRenderFns } from "./HomepageBuilder.vue?vue&type=template&id=05af090e&scoped=true"
import script from "./HomepageBuilder.vue?vue&type=script&lang=js"
export * from "./HomepageBuilder.vue?vue&type=script&lang=js"
import style0 from "./HomepageBuilder.vue?vue&type=style&index=0&id=05af090e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05af090e",
  null
  
)

export default component.exports